<template>
  <main-panel>
    <template slot="main-panel-links">
      <div class="navi-link mb-2">
        <router-link :to="{name:'home'}">
          Home <i class="fas fa-home" />
        </router-link>
      </div>
      <div class="navi-link">
        <router-link :to="{name:'client'}">
          Publisher Selection <i class="fas fa-user" />
        </router-link>
      </div>
      <div class="navi-link">
        <router-link :to="{name:'search'}">
          Search <i class="fas fa-search" />
        </router-link>
      </div>
      <div
        v-show="isConfigurationActive || isAlternativePaymentActive"
        class="navi-link"
      >
        <router-link :to="{ name: 'configuration', params: { clientId: clientSelectedCode }}">
          Configurations <i class="fas fa-cog fa-fw" />
        </router-link>
      </div>
      <div
        v-show="isConfigurationActive || isAlternativePaymentActive"
        class="navi-link"
      >
        <router-link :to="{ name: 'alternativePayments', params: { clientId: clientSelectedCode }}">
          Alternative Payments <i class="fa fa-file" />
        </router-link>
      </div>
      <div class="navi-link">
        <router-link :to="{ name: 'settings' }">
          Settings <i class="fa fa-cog" />
        </router-link>
      </div>
    </template>
    <template slot="main-panel-content">
      <div class="main-content">
        <router-view />
      </div>
    </template>
  </main-panel>
</template>

<script>
import MainPanel from '@/components/Layout/MainPanel'

export default {
  name: 'Payments',
  components: {
    MainPanel
  },
  computed: {
    isConfigurationActive() {
      return this.$route.name === 'configuration' || this.$route.name === 'editConfiguration'
    },
    isAlternativePaymentActive() {
      return this.$route.name === 'alternativePayments' || this.$route.name === 'editAlternativePayment'
    },
    clientSelectedCode() {
      return this.$route.params.clientId
    }
  },
  methods: {}
}
</script>

<style lang="scss">
  @import '~@/assets/styles/home.scss';
</style>
